// Fee for hiring a staffer from a job ad
export const HIRED_FEE = 3999 // for inviting global staffer to internals
export const HIRED_FROM_ADS_FEE = 3999
export const PREPAID_AD_FEE = 3999
export const HIRE_PENALTY = 10000
